module.exports = __webpack_public_path__ + "img/west-vvip-gal-15.cb55c96e.jpg";